/**
 *
 * Checks if the window object is available
 *
 * @returns Whether the window exists or not
 */
export const doesWindowObjectExist = (): boolean => {
  return typeof window !== 'undefined' && window !== null
}
